import React from 'react';
import { DefaultTheme } from 'styled-components';
import { Row, Space } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const ConnectedPage: React.FC = () => (
  <Space
    size={40}
    direction="vertical"
    css={`
      width: 100%;
      margin-top: 40px;
    `}
  >
    <Row justify="center">
      <CheckCircleOutlined
        css={`
          font-size: 4em;
          color: ${({ theme }: { theme: DefaultTheme }) => theme.primaryColor};
        `}
      />
    </Row>
    <Row>
      <h1>
        <FormattedMessage defaultMessage="You have successfully established a connection with DATEV Kassenarchiv online" />
      </h1>
      <p>
        <FormattedMessage defaultMessage="All your newly created daily closings will automatically be sent to DATEV Kassenarchiv. Your files will include all transactions (invoices and returns) and manually created cashbook entries according to the DFKA structure." />
      </p>
    </Row>
  </Space>
);

export default ConnectedPage;
